// const HUAWEI_TERMS = [/Huawei/i, /HMSCore/i, /HuaweiBrowser/i];
// const HUAWEI_REGEX =
//   /ALP-|AMN-|ANA-|ANE-|ANG-|AQM-|ARS-|ART-|ATU-|BAC-|BLA-|BRQ-|CAG-|CAM-|CAN-|CAZ-|CDL-|CDY-|CLT-|CRO-|CUN-|DIG-|DRA-|DUA-|DUB-|DVC-|ELE-|ELS-|EML-|EVA-|EVR-|FIG-|FLA-|FRL-|GLK-|HMA-|HW-|HWI-|INE-|JAT-|JEF-|JER-|JKM-|JNY-|JSC-|LDN-|LIO-|LON-|LUA-|LYA-|LYO-|MAR-|MED-|MHA-|MLA-|MRD-|MYA-|NCE-|NEO-|NOH-|NOP-|OCE-|PAR-|PIC-|POT-|PPA-|PRA-|RNE-|SEA-|SLA-|SNE-|SPN-|STK-|TAH-|TAS-|TET-|TRT-|VCE-|VIE-|VKY-|VNS-|VOG-|VTR-|WAS-|WKG-|WLZ-|YAL/i;
//
// // TODO: fix these links
// const HUAWEI_LINK = 'https://appgallery.huawei.com/app/';
const GOOGLE_LINK = 'https://play.google.com/store/apps/details?id=ai.abnk.app';

const androidStoreUrl = () => {
  // const userAgent = window.navigator.userAgent;
  // const includeHuaweiTerms = HUAWEI_TERMS.some(term => term.test(userAgent));
  // const isHuawei = includeHuaweiTerms || HUAWEI_REGEX.test(userAgent);
  // return isHuawei ? HUAWEI_LINK : GOOGLE_LINK;
  return GOOGLE_LINK
};

export default androidStoreUrl;
